import { type ReactNode, useEffect, useRef } from 'react';
import { Button } from './button';

/**
 * Модальное окно на нативном <dialog>: фокус, Esc и затемнение — силами браузера,
 * без зависимостей и inline-стилей (CSP).
 */
export function Dialog({
  open,
  title,
  description,
  onClose,
  children,
  footer,
}: {
  open: boolean;
  title: string;
  description?: ReactNode;
  onClose: () => void;
  children?: ReactNode;
  footer?: ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      onClose={onClose}
      className="m-auto w-[min(100%-32px,var(--container-form))] rounded-lg border-0 bg-canvas p-0 text-body shadow-dialog backdrop:bg-overlay"
    >
      {open && (
        <>
          <div className="grid gap-1 px-6 pt-6">
            <h2 className="text-lg font-semibold tracking-[-0.2px] text-ink">{title}</h2>
            {description && <div className="text-sm text-body">{description}</div>}
          </div>
          {children && <div className="grid gap-4 px-6 py-4">{children}</div>}
          <div className="flex flex-wrap justify-end gap-2 px-6 pt-2 pb-6">
            {footer ?? (
              <Button variant="secondary" onClick={onClose}>
                OK
              </Button>
            )}
          </div>
        </>
      )}
    </dialog>
  );
}
